import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import { parse, isValid, format, isAfter } from "date-fns";
import "../../stylesheets/calendar.scss";
import PreviousResponse from '../previous-response/previous_response.jsx';

export const DateInput = ({ label, onValueChange, initValue, lastSurveyResponseHeader, lastSurveyResponseText }) => {
  const [calendarValue, setCalendarValue] = useState(null);
  const [date, setDate] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const today = new Date();
  const dateFormat = "dd/MM/yyyy";

  useEffect(() => {
    if (!initValue || typeof initValue !== "string") return;

    const parsedDate = parse(initValue, dateFormat, today);

    // Allow initValue date if valid and not after today
    if (isValid(parsedDate) && !isAfter(parsedDate, today)) {
      setCalendarValue(parsedDate);
      setDate(initValue);
    }
  }, [initValue]);

  const handleChange = (value) => {
    if (!value) return;
    // Allow selection if not after today (i.e., today or past)
    if (!isAfter(value, today)) {
      const formattedDate = format(value, dateFormat);
      setCalendarValue(value);
      setDate(formattedDate);
      setShowCalendar(false);
      onValueChange({ key: 0, value: formattedDate });
    }
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    // Allow partial dd/MM/yyyy input
    if (/^\d{0,2}\/?\d{0,2}\/?\d{0,4}$/.test(inputValue)) {
      setDate(inputValue);
    }
    setShowCalendar(false);
  };

  const handleBlur = () => {
    if (!date) {
      setCalendarValue(null);
      onValueChange({ key: 0, value: "" });
      return;
    }

    // Parse input date string (expects format "dd/MM/yyyy")
    const parsedDate = parse(date, dateFormat, today);

    // Allow input if valid and not after today (today included)
    if (isValid(parsedDate) && !isAfter(parsedDate, today)) {
      setCalendarValue(parsedDate);
      onValueChange({ key: 0, value: format(parsedDate, dateFormat) });
      return;
    }

    // Reset to last valid date or empty string on invalid input
    if (calendarValue) {
      setDate(format(calendarValue, dateFormat));
    } else {
      setDate("");
    }
  };

  return (
    <div
      className="date-input"
      style={{ marginBottom: "25px", marginTop: "25px" }}
    >
      <p
        className="title"
        style={{ "fontSize": "20px", "marginBottom": "10px", "textAlign": "left" }}
      >
      {label + ' (DD/MM/YYYY)'}
      </p>
      {
          lastSurveyResponseText && (
            <PreviousResponse
              responseHeader={lastSurveyResponseHeader}
              responseText={lastSurveyResponseText}
            />
          )
        }
      <div
        className="calendar-input-field"
        style={{
          "backgroundColor": "#e4e4e4",
          "height": "40px",
          "borderRadius": "5px",
          "display": "flex",
          "alignItems": "center",
          "position": "relative",
        }}
      >
        <input
          className="input"
          onClick={() => setShowCalendar(!showCalendar)}
          onChange={handleInputChange}
          onBlur={handleBlur}
          style={{
            "height": "32px",
            "display": "block",
            "color": "rgba(0, 0, 0, 0.87)",
            "border": "none",
            "outline": "0",
            "width": "100%",
            "boxSizing": "border-box",
            "fontSize": "16px",
            "padding": "8px 30px 0px 10px",
            "backgroundColor": "transparent",
            "textAlign": "inherit",
            "zIndex": "3",
            "position": "relative",
            "letterSpacing": "1px",
          }}
          type="text"
          value={date}
          placeholder="DD/MM/YYYY"
        />
      </div>
      {showCalendar && (
        <div className="calendar-wrapper">
          <Calendar
            maxDate={today}
            onChange={handleChange}
            value={calendarValue}
          />
        </div>
      )}
    </div>
  );
};
